import { Button } from 'primereact/button';
import './App.css';
import PageMarketingV2AvailableAds from './PageMarketingV2AvailableAds';
import TotemMini from './TotemMini';
import { useNavigate } from 'react-router-dom';

function PageMarketingV2PresentTechnology({
    creativeURL,
    setCreativeURL,
    color,
}) {
    const navigate = useNavigate();

    return (
        <div
            className='mk2-dark'
        >
            <div className='mk2-title'>
                Technology
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                }}>
                <TotemMini
                    creativeURL={creativeURL}
                    color={color}
                />
                <PageMarketingV2AvailableAds
                    creativeURL={creativeURL}
                    setCreativeURL={setCreativeURL}
                />
            </div>
            <div
                style={{ marginTop: '2em' }}
            >
                <div
                    className='mk2-subtitle'
                    style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                    }}
                >
                    Starting from
                </div>
                <div className='mk2-title'>
                    4.9 EUR / month
                </div>
                <div>
                    <Button
                        label="View Offers"
                        severity="success"
                        outlined
                        size='small'
                        onClick={
                            () => navigate('/v2/pricing')
                        }
                    />
                </div>
            </div>
        </div>
    );
}

export default PageMarketingV2PresentTechnology;